import { Col } from 'antd'
import { RightOutlined, DownOutlined } from '@ant-design/icons'
import { useAppDispatch } from 'hooks'
import { getAnswers } from 'Services/Settings/SettingsService'
import { setCollapse } from 'Helpers/SettingsHelper'
import { QuestionGroup, setSettingLoading } from 'Slices/Settings/SettingsSlice'

interface FatherCollapseProps {
  settingsName: string
  translation: string
  collapse: string[]
  extraChild: QuestionGroup[] | null
  setCollapse: React.Dispatch<React.SetStateAction<any[]>>
  setExtraCollapse: React.Dispatch<React.SetStateAction<any[]>> | null
}

function FatherCollapseHeader(props: FatherCollapseProps) {
  const dispatch = useAppDispatch()

  const retrieveAnswers = async () => {
    dispatch(setSettingLoading(true))
    await dispatch(getAnswers(props.settingsName))
    dispatch(setSettingLoading(false))
  }

  return (
    <Col
      span={24}
      className={'header-row' + (props.collapse.indexOf(props.settingsName) !== -1 ? ' expanded' : '')}
      id={`question-${props.settingsName}`}
      onClick={() => {
        setCollapse(props.setCollapse, props.settingsName)

        //if has child and extraCollapse invocation is a father header
        if (props.extraChild && props.setExtraCollapse) {
          if (props.collapse.indexOf(props.settingsName) === -1) {
            retrieveAnswers()
          } else {
            props.setExtraCollapse(oldArray => {
              return oldArray.filter(x => Object.keys(props.extraChild).indexOf(x) !== -1)
            })
          }
        }
      }}
    >
      <div className='d-inline-flex'>
        <p className='setting-name'>{props.translation}</p>
      </div>
      {props.collapse.indexOf(props.settingsName) !== -1 ? (
        <DownOutlined className='generic-icon d-inline-flex' />
      ) : (
        <RightOutlined className='generic-icon d-inline-flex' />
      )}
    </Col>
  )
}

export default FatherCollapseHeader
